module.exports = __webpack_public_path__ + "static/media/alert-gray.0b9ff0d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dealroom-icons/alert-gray.svg
// module id = 1484
// module chunks = 0